export function FormatToBRLCurrency(input: number | string): string {
   const number = typeof input === 'string' ? parseFloat(input) : input;
   
   if (isNaN(number)) {
       throw new Error('Entrada deve ser um número válido.');
   }

   const parts: string[] = number.toFixed(2).split('.');
   const integerPart: string = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
   
   return `R$ ${integerPart},${parts[1]}`;
}